import { render, staticRenderFns } from "./AboutEstar.vue?vue&type=template&id=c4485bf2&scoped=true"
import script from "./AboutEstar.vue?vue&type=script&lang=js"
export * from "./AboutEstar.vue?vue&type=script&lang=js"
import style0 from "./AboutEstar.vue?vue&type=style&index=0&id=c4485bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4485bf2",
  null
  
)

export default component.exports